import React, { useEffect } from 'react'
import type { SelectFieldProps } from './Select.types'
import SelectStatic from './SelectStatic'
import SelectChips from './SelectChips'
import SelectLookup from './SelectLookup'

export default function SelectField(props: SelectFieldProps) {
  const { __onMounted } = props

  useEffect(() => {
    __onMounted?.()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  switch (props.mode) {
    case 'static':
      return <SelectStatic {...props} />
    case 'static-chips':
    case 'lookup-chips':
      return <SelectChips {...props} />
    case 'lookup':
      return <SelectLookup {...props} />
  }
}
